// extracted by mini-css-extract-plugin
export default {"main":"SideBar_main__jmeac","title":"SideBar_title__GtMLa","closeButton":"SideBar_closeButton__48InL"};